// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"4860987f","796":"158df0d5"}[chunkId] + ".chunk.js";
};